export default "<div id=\"cuerpo\">\n  <app-aside></app-aside>\n\n  <hr />\n  <div class=\"col_derecha\">\n\n  </div>\n\n  <br class=\"limpiar\" />\n</div>\n"